import './quietConsole.js';
// main.js
import './style.css';
import * as bootstrap from 'bootstrap';
// Globaal voor de inline tooltip-init in index.html.
window.bootstrap = bootstrap;
import { getMap } from './mapInstance.js';
import { setupDrawTools } from './drawTools.js';
import { observeInfoButtonAndInit  } from './featureinfo.js';
import { setupSearchByLocation } from './searchByLocation.js';
import { toggleDragZoom, deactivateDragZoom, isDragZoomActive } from './Magnify.js';
import * as MapUtils from './mapUtils.js';
import { adjustStatusBar, enableStatusBarAutoHide, waitForAllFeaturesLoaded, cancelActiveTools, updateBaseLegendMessage } from './mapUtils.js';
import LayerSwitcher from 'ol-layerswitcher';
import Group from 'ol/layer/Group';
import { activatePanMode } from './panUtils.js';
import { setupCountryLanguageSelectors } from './country-language.js';
import './exportData.js';
import './layerInfo.js';
import { createOverlayGroup  } from './overlayLayers.js';
import { setupBookmarkForm, loadBookmarks } from './bookmarks.js';
import { setupUploadModule } from './uploadModule.js';
import { createAuthorizedMap, startApp } from "./authBootstrap.js";
import { initSearchByLocationLayer } from './searchByLocation.js';
import { fitBaseLayers } from './loadBaseLayers.js';
import { resetApplication, resetActiveCommandsOnly } from "./resetApplication.js";
import { initLayerControls } from './layerHierarchyService.js';
import * as AddressSearch from './addressSearch.js';
import { setUserRights, applyRightsToDOM } from './rightsUtil.js';
import { initFeaturesByRights } from './featureManager.js';
import { canUseAddressAidsDraw, updateAddressAidsDrawButtons } from './addressAidsAvailability.js';
import { API_URL } from './config.js';
import { clearTokens } from './securityUtil.js';
import { initDialogToolActiveState, initFloatingDialogStacking } from './dialogs.js';
import { refreshBootstrapTooltip, translate } from './languageTranslator.js';

initFloatingDialogStacking();
initDialogToolActiveState();

let userRightsLoaded = false;
let mapInstanceReady = false;
let mapRef = null;
let currentResultsAutoTriggered = false;
let resolveMapReadySetupComplete = null;
const mapReadySetupComplete = new Promise(resolve => {
  resolveMapReadySetupComplete = resolve;
});

function ensureMapWatermark() {
  const mapDiv = document.getElementById('map');
  if (!mapDiv) return;

  let watermark = document.getElementById('map-watermark');
  if (!watermark) {
    watermark = document.createElement('div');
    watermark.id = 'map-watermark';
    watermark.textContent = 'Version v1.0.6.13 | Released: 20-June-2026';
  }

  if (watermark.parentElement !== mapDiv) {
    mapDiv.appendChild(watermark);
  }
}

async function loadCurrentResultsAfterMapReady() {
  if (currentResultsAutoTriggered) return;

  if (!mapRef) return;

  const country = document.getElementById('country-select')?.value;
  const language = document.getElementById('language-select')?.value;

  if (!country || !language) return;

  currentResultsAutoTriggered = true;

  const { loadFromBackend } = await import('./drawSummaryPanel.js');
  await loadFromBackend();
}

function queueCurrentResultsLoad() {
  loadCurrentResultsAfterMapReady().catch(err => {
    currentResultsAutoTriggered = false;
    console.error('Auto Current Results failed', err);
  });
}

function bindAddressAidsAvailabilityUpdates(layerCollection, map) {
  layerCollection?.forEach(layer => {
    layer.on?.('change:visible', () => updateAddressAidsDrawButtons(map));
    layer.on?.('change:visible', () => import('./pcSelection.js').then(mod => mod.updatePCSelectionButtons(map)));

    if (typeof layer.getLayers === 'function') {
      bindAddressAidsAvailabilityUpdates(layer.getLayers(), map);
    }
  });
}

// -----------------------
// Layer Groups
// -----------------------
const base_map = new Group({ title: 'BaseData', layers: [], zIndex:3 });
const own_map = new Group({ title: 'Own Data', layers: [], zIndex:1 });

window.base_map = base_map;
//window.overlays = overlay_map;
window.own_map = own_map;

window.MapUtils = MapUtils;
window.layerName = 'geolinq:nl_full_address';


// Layer switcher
const layerSwitcher = new LayerSwitcher({
  activationMode: 'click',
  startActive: true,
  tipLabel: 'Layers',
  groupSelectStyle: 'children',
  collapseTipLabel: 'Collapse layers',
});
//map.addControl(layerSwitcher);


function tryInitFeatures() {
  if (userRightsLoaded && mapInstanceReady) {
    initFeaturesByRights({
      map: mapRef
    });
  }
}

function setSidebarToolbarExpanded(expanded) {
  const sidebar = document.getElementById('sidebar');
  const toggle = document.getElementById('sidebar-menu-toggle');

  if (!sidebar || !toggle) return;

  // console.log('[Sidebar Toolbox] setSidebarToolbarExpanded', {
  //   expanded,
  //   beforeClasses: sidebar.className,
  //   beforeWidth: sidebar.style.width || '(empty)'
  // });

  sidebar.classList.toggle('is-expanded', expanded);
  sidebar.classList.toggle('is-collapsed', !expanded);
  sidebar.style.width = expanded ? '60px' : '38px';
  toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  const toggleLabel = expanded ? translate('sidebar.toggle.close_menu') : translate('sidebar.toggle.open_menu');
  toggle.setAttribute('title', toggleLabel);
  toggle.setAttribute('data-bs-title', toggleLabel);
  toggle.setAttribute('data-bs-original-title', toggleLabel);
  toggle.setAttribute('aria-label', toggleLabel);
  refreshBootstrapTooltip(toggle, toggleLabel);
  toggle.innerHTML = expanded
    ? '<i class="bi bi-x-lg fs-6"></i>'
    : '<i class="bi bi-list fs-6"></i>';

  // console.log('[Sidebar Toolbox] setSidebarToolbarExpanded applied', {
  //   afterClasses: sidebar.className,
  //   afterWidth: sidebar.style.width,
  //   ariaExpanded: toggle.getAttribute('aria-expanded')
  // });
}

function initSidebarToolbarToggle() {
  const sidebar = document.getElementById('sidebar');
  const toggle = document.getElementById('sidebar-menu-toggle');

  if (!sidebar || !toggle || toggle.dataset.sidebarToggleBound === 'true') return;

  toggle.dataset.sidebarToggleBound = 'true';
  setSidebarToolbarExpanded(sidebar.classList.contains('is-expanded'));

  if (!document.body?.dataset.sidebarClickBound) {
    document.body.dataset.sidebarClickBound = 'true';
    document.addEventListener('click', (event) => {
      const currentSidebar = document.getElementById('sidebar');
      const currentToggle = document.getElementById('sidebar-menu-toggle');
      if (!currentSidebar || !currentToggle) return;

      const rect = currentToggle.getBoundingClientRect();
      const inToggle =
        event.clientX >= rect.left &&
        event.clientX <= rect.right &&
        event.clientY >= rect.top &&
        event.clientY <= rect.bottom;

      // console.log('[Sidebar Toolbox] document click', {
      //   targetId: event.target && event.target.id,
      //   currentTargetTag: event.currentTarget && event.currentTarget.tagName,
      //   inToggle,
      //   sidebarClasses: currentSidebar.className,
      // });

      if (!inToggle) return;

      event.preventDefault();
      event.stopPropagation();
      setSidebarToolbarExpanded(!currentSidebar.classList.contains('is-expanded'));
    }, true);
  }
}

// -----------------------
// Setup search by location
// -----------------------
function initSearch() {
  setupSearchByLocation();
}


document.addEventListener("map-ready", async (e) => {

  if (!e.detail) {
    console.error("map-ready fired without map", e);
    resolveMapReadySetupComplete?.();
    return;
  }

  const map = e.detail;

  mapInstanceReady = true;
  mapRef = e.detail;
  ensureMapWatermark();

  tryInitFeatures();

  const layers = map.getLayers().getArray();

  if (!layers.includes(window.base_map)) {
    map.addLayer(window.base_map);
  }

  if (window.overlays && !layers.includes(window.overlays)) {
    map.addLayer(window.overlays);
  }

  if (!layers.includes(window.own_map)) {
    map.addLayer(window.own_map);
  }

  // -----------------------
  // Zoom info
  // -----------------------
  MapUtils.updateLayerVisibilityByZoom(window.base_map);
  MapUtils.updateZoomInfo(map);
  updateAddressAidsDrawButtons(map);
  import('./pcSelection.js').then(mod => mod.updatePCSelectionButtons(map));
  map.getView().on('change:resolution', () => {
    MapUtils.updateLayerVisibilityByZoom(window.base_map);
    MapUtils.updateZoomInfo(map);
    updateAddressAidsDrawButtons(map);
    import('./pcSelection.js').then(mod => mod.updatePCSelectionButtons(map));
  });
  map.on('moveend', () => {
    MapUtils.updateLayerVisibilityByZoom(window.base_map);
    MapUtils.updateZoomInfo(map);
    updateAddressAidsDrawButtons(map);
    import('./pcSelection.js').then(mod => mod.updatePCSelectionButtons(map));
  });


  // Set zoom control position
  map.getControls().forEach(control => {
    if (control.element && control.element.classList.contains('ol-zoom')) {
      control.element.style.left = 'unset';
      control.element.style.right = '20px';
      control.element.style.top = 'unset';
      control.element.style.bottom = '20px';
      control.element.style.position = 'absolute';
    }
  });


  await setupCountryLanguageSelectors(map, () => {
    loadBookmarks(); // reload bookmarks when country changes
  });
  AddressSearch.initDrawLayer();
  queueCurrentResultsLoad();

  adjustStatusBar();
  enableStatusBarAutoHide();
  
  await waitForAllFeaturesLoaded(map);
  setupDrawTools();

  // Initial render
  updateBaseLegendMessage(window.base_map);

  window.base_map.getLayers().forEach(layer => {
    layer.on('change:visible', () => {
      updateBaseLegendMessage(window.base_map);
      updateAddressAidsDrawButtons(map);
      import('./pcSelection.js').then(mod => mod.updatePCSelectionButtons(map));
    });
  });
  bindAddressAidsAvailabilityUpdates(window.base_map.getLayers(), map);

  // Update on zoom (MANDATORY)
  map.getView().on('change:resolution', () => {
    MapUtils.updateLayerVisibilityByZoom(window.base_map);
    updateBaseLegendMessage(window.base_map);
    updateAddressAidsDrawButtons(map);
    import('./pcSelection.js').then(mod => mod.updatePCSelectionButtons(map));
  });

  resolveMapReadySetupComplete?.();



});

document.addEventListener('base-layers-updated', () => {
  const map = getMap();
  if (!map) return;

  MapUtils.updateLayerVisibilityByZoom(window.base_map);

  // also rebind visibility listeners for newly added layers
  window.base_map.getLayers().forEach(layer => {
    layer.on('change:visible', () => {
      updateBaseLegendMessage(window.base_map);
      updateAddressAidsDrawButtons(map);
      import('./pcSelection.js').then(mod => mod.updatePCSelectionButtons(map));
    });
  });
  bindAddressAidsAvailabilityUpdates(window.base_map.getLayers(), map);
  updateAddressAidsDrawButtons(map);
  import('./pcSelection.js').then(mod => mod.updatePCSelectionButtons(map));
});

document.addEventListener("DOMContentLoaded", async () => {
  document.documentElement.classList.add('auth-pending');
  const authResult = startApp();

  if (!authResult.authorized) {
    clearTokens();
    showUnauthorizedMessage(authResult.reason);
    return;
  }

  try {
    const response = await fetch(`${API_URL}user-rights/${encodeURIComponent(authResult.jwtContext.userId)}`, {
      headers: {
        Authorization: `Bearer ${authResult.token}`,
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      const error = new Error(`Rights request rejected with status ${response.status}`);
      error.authorizationReason = response.status === 401 ? 'invalid' : 'rights';
      throw error;
    }

    const data = await response.json();
    const rights = Array.isArray(data?.rights)
      ? data.rights
      : typeof data?.rights === 'string'
        ? data.rights.split(';').map(right => right.trim()).filter(Boolean)
        : [];
    const rightsRequestSucceeded = !data?.status || data.status === 'Success';

    if (!rightsRequestSucceeded || rights.length === 0) {
      throw new Error(data?.message || 'No rights returned for user');
    }

    setUserRights(rights);
    userRightsLoaded = true;
    initSidebarToolbarToggle();

    document.documentElement.classList.remove('auth-pending');
    const mapDiv = document.getElementById('map');
    if (mapDiv) mapDiv.innerHTML = '';

    window.overlays = createOverlayGroup();
    createAuthorizedMap(authResult.jwtContext);

    await new Promise(resolve => setTimeout(() => {
      applyRightsToDOM();

      const searchBtn = document.getElementById("search-button");
      searchBtn && (searchBtn.onclick = (e) => {
        e.preventDefault();
        AddressSearch.query();
      });

      const clearBtn = document.getElementById("clearSelection");
      clearBtn && (clearBtn.onclick = (e) => {
        e.preventDefault();
        AddressSearch.clearAddressSearchResults();
      });

      const showBtn = document.getElementById("showResultsButton");
      showBtn && (showBtn.onclick = (e) => {
        e.preventDefault();
        AddressSearch.showResultsTable();
      });

      resolve();
    }, 0));

    mapReadySetupComplete
      .then(() => new Promise(resolve => requestAnimationFrame(resolve)))
      .then(queueCurrentResultsLoad);
  } catch (error) {
    console.error('Application authorization failed:', error);
    clearTokens();
    showUnauthorizedMessage(error.authorizationReason || 'rights');
  }

});

document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => {
  new bootstrap.Tooltip(el);
});

MapUtils.makeDraggable(
  document.getElementById('search-form'),
  document.getElementById('search-form-header')
);

MapUtils.makeDraggable(
  document.getElementById('draw-panel'),
  document.getElementById('draw-panel-header')
);

MapUtils.makeDraggable(
  document.getElementById('layer-info-panel'),
  document.getElementById('layer-info-header')
);

MapUtils.makeDraggable(
  document.getElementById('pc-panel'),
  document.getElementById('pc-panel-header')
);

function showUnauthorizedMessage(reason = "missing") {
  let title = translate("auth.unauthorized_header");
  let message = translate("auth.missing_session_body");

  if (reason === "expired") {
    title = translate("auth.expired_session_header");
    message = translate("auth.expired_session_body");
  }

  if (reason === "invalid") {
    title = translate("auth.invalid_session_header");
    message = translate("auth.invalid_session_body");
  }

  if (reason === "rights") {
    title = translate("auth.unauthorized_header");
    message = translate("auth.invalid_session_body");
  }

  document.documentElement.classList.remove("auth-pending", "rights-ready");
  document.querySelectorAll(
    '#sidebar, #status-bar, .ol-control, .tool-panel, #search-form, #draw-panel, #layer-info-panel, #pc-panel'
  ).forEach(element => {
    element.style.display = 'none';
  });

  const mapDiv = document.getElementById('map');
  if (mapDiv) {
    mapDiv.innerHTML = `
      <div style="
        display:flex;
        align-items:center;
        justify-content:center;
        height:100%;
        font-family:system-ui;
        text-align:center;
        padding:20px;
      ">
        <div>
          <h3>${title}</h3>
          <p>${message}</p>
        </div>
      </div>
    `;
  }
}


